import { useQueryClient } from '@tanstack/react-query';
import { type FileAsset, createFileAsset } from 'models';
import { useMutation } from 'query';
import type { FileAssetsDataObject } from 'models/service';
import { createAsset } from '../../services';
import { assetsFeatureKey } from '../keys';

export const useCreateAssetMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<FileAsset, { communityId?: string; file: File; parentId: null | string; programId?: string }>({
    async mutationFn({ communityId, file, parentId, programId }) {
      const body = new FormData();

      body.append('file', file);
      body.append('name', file.name);
      body.append('type', 'file');

      if (communityId) {
        body.append('community_id', communityId);
      }

      if (programId) {
        body.append('program_id', programId);
      }

      if (parentId) {
        body.append('parent_id', parentId);
      }

      const response = await createAsset({ body });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- The create endpoint returns a file when the request created a file
      return createFileAsset(response.data as unknown as FileAssetsDataObject);
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: assetsFeatureKey });
    },
  });
};
